import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { Observable } from 'rxjs/Rx';
import { Action, Store } from '@ngrx/store';
import { defer } from 'rxjs/observable/defer';
import * as sharedActions from '../actions/shared.actions';
import { AuthData } from '../../providers/auth';
import { HistoryData } from '../../providers/history';
import { Utilities } from '../../providers/utilities';
import { NavController, App, MenuController } from 'ionic-angular';

@Injectable()
export class SharedEffects {

  @Effect({ dispatch: false })
  clientConfig$ = this.actions
    .ofType(sharedActions.LOAD_CLIENT)
    .switchMap(() => this.authData.getUser())
    .switchMap((currentUser: any) => {
      this.utilities.consoleDecorator('[effect] dispatch clientConfig$ ', currentUser);
      if (!currentUser) {
        this.utilities.consoleDecorator('User not found', currentUser)
        this.menuCtrl.enable(false, 'main-menu');

        setTimeout(() => {
          this.utilities.consoleDecorator('Redirect to Login', currentUser)
          this._navCtrl.setRoot('LoginPage', {}, { animate: true, direction: 'forward' });
        }, 100);

        setTimeout(() => {
          document.getElementById('splashContainer').style.opacity = '0';
          document.getElementById('splashContainer').style.zIndex = '-1';
        }, 900);

        return Observable.empty();
      } else {
        return this.authData.getClient(currentUser.uid);
      }
    })
    .map((client: any) => {
      setTimeout(() => {
        document.getElementById('splashContainer').style.opacity = '0';
        document.getElementById('splashContainer').style.zIndex = '-1';
      }, 900);

      if (client) {
        this.utilities.consoleDecorator('User found', client);

        if (!this._navCtrl.getViews().length) {
          setTimeout(() => {
            this._navCtrl.setRoot('HomePage', {}, { animate: true, direction: 'forward' });
          }, 100);
        } else if (this._navCtrl.getActive().name === 'LoginPage') {
          setTimeout(() => {
            this._navCtrl.setRoot('HomePage', {}, { animate: true, direction: 'forward' });
          }, 100);
        }

        this.menuCtrl.enable(true, 'main-menu');

        return this.store.dispatch(new sharedActions.LoadClientSubmit(client));
      } else {
        this.utilities.consoleDecorator('User not found', client)
        this.authData.logoutUser();
        setTimeout(() => {
          this._navCtrl.setRoot('LoginPage', {}, { animate: true, direction: 'forward' });
        }, 100);
        this.menuCtrl.enable(false, 'main-menu');
        return this.store.dispatch(new sharedActions.LoadClientFailed());
      }
    });

  // @Effect({ dispatch: false })
  // loadFailed$ = this.actions
  //   .ofType(sharedActions.LOAD_CLIENT_FAILED)
  //   .switchMap(() => this.authData.logoutUser());

  @Effect({ dispatch: false })
  ipConfig$ = this.actions
    .ofType(sharedActions.LOAD_CLIENT_SUBMIT)
    .switchMap(() => this.history.getMyIp())
    .map((data: any) => {
      return this.store.dispatch(new sharedActions.LoadIpSubmit(data.ip));
    });

  @Effect()
  public init$: Observable<Action> = defer(() => Observable.of(
    new sharedActions.LoadClient()
  ));

  private get _navCtrl(): NavController {
    return this.appCtrl.getRootNav();
  }

  public constructor(
    private authData: AuthData,
    private actions: Actions,
    private store: Store<{}>,
    private history: HistoryData,
    private utilities: Utilities,
    private appCtrl: App,
    private menuCtrl: MenuController
  ) { }
}



// WEBPACK FOOTER //
// ./src/shared/effects/shared.effects.ts